import { TAction, TActionRequest } from "../../base/types/redux";
import {
  GetSurveyOptionsResponse,
  CreateHealthCheckRequest,
  ApiStateType,
  GetHealthCheckInfoResponse
} from "../utils/types";
import { ACTION_TYPES } from "./actionTypes";

export const getSurveyOptions = (params: any): TActionRequest<any> => {
  return {
    type: ACTION_TYPES.GET_SURVEY_OPTIONS,
    params,
  };
};

export const setSurveyOptions = (response: GetSurveyOptionsResponse): TAction => {
  return {
    type: ACTION_TYPES.SET_SURVEY_OPTIONS,
    response,
  };
};

export const postCreateHealthCheck = (params: CreateHealthCheckRequest): TActionRequest<CreateHealthCheckRequest> => {
  return {
    type: ACTION_TYPES.POST_CREATE_HEALTH_CHECK,
    params,
  };
};

export const setCreateHealthCheckState = (response: ApiStateType): TAction => {
  return {
    type: ACTION_TYPES.SET_CREATE_HEALTH_CHECK_STATE,
    response,
  };
};

export const getHealthCheckInfo = (): TActionRequest<null> => {
  return {
    type: ACTION_TYPES.GET_HEALTH_CHECK_INFO,
    // params,
  };
};

export const setHealthCheckInfo = (response: GetHealthCheckInfoResponse): TAction => {
  return {
    type: ACTION_TYPES.SET_HEALTH_CHECK_INFO,
    response,
  };
};